import { Pipe, PipeTransform } from '@angular/core';
import { Config, OccConfig } from '@spartacus/core';

@Pipe({
  name: 'sdUrlMedia',
  standalone: true,
})
export class UrlMediaPipe implements PipeTransform {
  constructor(private config: Config) {}

  transform(url: string): string {
    return this.resolveAbsoluteUrl(url);
  }

  /**
   * The base URL is either driven by a specific `backend.media.baseUrl`, or by the
   * `backend.occ.baseUrl`.
   *
   * The `backend.media.baseUrl` can be used to load media from a different location.
   *
   * In Commerce Cloud, a differnt location could mean a different "aspect".
   */
  protected getBaseUrl(): string {
    return (this.config as OccConfig).backend.media.baseUrl || (this.config as OccConfig).backend.occ.baseUrl || '';
  }

  /**
   * Resolves the absolute URL for the given url. In most cases, this URL represents
   * the relative URL on the backend. In that case, we prefix the url with the baseUrl.
   */
  private resolveAbsoluteUrl(url: string): string {
    if (!url) {
      return null;
    }

    return url.startsWith('http') || url.startsWith('//') ? url : this.getBaseUrl() + url;
  }
}
